import {Actions, createEffect, ofType, ROOT_EFFECTS_INIT} from '@ngrx/effects';
import {catchError, EMPTY, switchMap, tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {WireTransferBankApi} from "@modules/wire-transfer-bank/api/wire-transfer-bank.api";
import {WireTransferBankService} from "@modules/wire-transfer-bank/services/wire-transfer-bank.service";

@Injectable()
export class WireTransferBankInitializerEffects {
  initWireTransferBanks$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      switchMap(() => this.wireTransferBankApi.get$()),
      tap(banks => this.wireTransferBankService.dispatchSetEntities(banks)),
      catchError(e => {
        console.error(e);

        this.wireTransferBankService.dispatchClearEntitiesAction()

        return EMPTY;
      }),
    )
  }, {
    dispatch: false
  });

  constructor(
    private actions$: Actions,
    private wireTransferBankApi: WireTransferBankApi,
    protected readonly wireTransferBankService: WireTransferBankService
  ) {
  }
}
